// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

import React, {useState} from 'react'
import {QueryClient, QueryClientProvider } from 'react-query'
import {BackendModel} from './BackendModel.js'
import {Carsharing} from './Carsharing.js'
import {API_URL} from './Environment.js'
import {Login} from './Login.js'
import {strings} from './Localization.js'
import { useAuth } from "react-oidc-context";
import './App.css'

const queryClient = new QueryClient()

export default function App(props) {
  const [errorMessage, setErrorMessage] = useState(null)
  const auth = useAuth();

  if (auth.isLoading) {
    return <h2>{strings.loading}</h2>
  }
  return (
      <QueryClientProvider client={queryClient}>
        {errorMessage && <div className="message-box">
          <div className="error-message">{errorMessage}</div>
          <button onClick={() => setErrorMessage(null)}>Ok</button></div>}
        {(!auth.isAuthenticated)
        ? <Login
            onSubmit={() => auth.signinRedirect() } />
        : <Carsharing
            queryClient={queryClient}
            username={auth.user?.profile.preferred_username}
            backend={new BackendModel(API_URL, auth.user?.access_token)}
            onLogout={() => auth.signoutRedirect() }
            onError={setErrorMessage}/>}
      </QueryClientProvider>)
}
